import { useUsersStore } from "@/store/modules/users";

const storageKey = (listName) =>
  `atmo:list-query:${listName}:${useUsersStore().currentUserEmail ?? ""}`;

export const saveListQuery = (listName, query) => {
  try {
    localStorage.setItem(storageKey(listName), JSON.stringify(query));
  } catch {
    // Storage inaccessible (navigation privée)
  }
};

export const readListQuery = (listName) => {
  try {
    return JSON.parse(localStorage.getItem(storageKey(listName))) ?? {};
  } catch {
    return {};
  }
};

export const restoreListQuery = (listName) => (to) => {
  if (Object.keys(to.query).length) return true;
  const query = readListQuery(listName);
  if (!Object.keys(query).length) return true;
  return { ...to, query, replace: true };
};
